'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var CsrSignInForm_module = require('./CsrSignInForm.module.css.js');
var nthBitHeader = require('@narvar/nth-bit-header');
var Button = require('@narvar/nth-block-button');
var TextInput = require('@narvar/nth-block-text-input');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var tokens = require('./tokens.js');
var index = require('../Language/index.js');
require('../Spinner/Spinner.module.css.js');
require('@babel/runtime/helpers/extends');
require('../LocationCard/LocationCard.js');
require('../PudoCard/PudoCard.js');
require('../ItemCard/ItemCard.js');
require('../SelectItem/SelectItem.js');
require('../SelectList/SelectList.js');
var ErrorBanner = require('../ErrorBanner/ErrorBanner.js');
require('../Footer/Footer.js');
require('../StickyFooter/StickyFooter.js');
require('../SwatchesList/SwatchesList.js');
require('@narvar/nth-bit-text-link');
require('../Backdrop/Backdrop.module.css.js');
require('../LineItemsGroup/index.js');
require('../Skeleton/Skeleton.module.css.js');
var language_en_US = require('../../consts/language_en_US.js');
var ReturnsConfigProvider = require('../../providers/ReturnsConfigProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var TextInput__default = /*#__PURE__*/_interopDefaultLegacy(TextInput);

const tempLanguageKeys = {
  returnsCsrSignInError401: language_en_US["default"].returnsCsrSignInError401,
  returnsCsrSignInError500: language_en_US["default"].returnsCsrSignInError500,
  returnsCsrSignInTitle: language_en_US["default"].returnsCsrSignInTitle,
  returnsCsrSignInDetails: language_en_US["default"].returnsCsrSignInDetails,
  returnsCsrSignInOrderPlaceholder: language_en_US["default"].returnsCsrSignInOrderPlaceholder,
  returnsCsrSignInPrimaryButton: language_en_US["default"].returnsCsrSignInPrimaryButton
};

/** // ToDo: nth needs a local and session storage utils library.
 * Sets an item in sessionStorage
 * @param {String} key - the key to use when setting the item in sessionStorage.
 * @param {unknown} value - the value of the sessionStorage item.
 */
const setSessionStorageItem = (key, value) => {
  try {
    const serializedValue = JSON.stringify(value);
    sessionStorage.setItem(key, serializedValue);
  } catch (err) {
    var _window;
    (_window = window) === null || _window === void 0 ? void 0 : _window.console.warn(err);
  }
};
/**
 * Gets an item from sessionStorage
 * @param {String} key - the sessionStorage key to get.
 * @returns {unknown} value stored indexed by key in sessionStorage.
 *                It returns undefined if:
 *                a) key is not in sessionStorage
 *                b) an error occurred
 */
const getSessionStorageItem = key => {
  try {
    const serializedItem = window.sessionStorage.getItem(key);
    if (serializedItem === null) {
      return undefined;
    }
    return JSON.parse(serializedItem);
  } catch (err) {
    return undefined;
  }
};
const CsrSignInErrorMessage = _ref => {
  let {
    csrSignInErrorCode
  } = _ref;
  const {
    returnsCsrSignInError401,
    returnsCsrSignInError500
  } = nthHookTranslations.useTranslations();
  if (csrSignInErrorCode === 401) {
    return /*#__PURE__*/React__default["default"].createElement(index["default"], {
      langKey: "returnsCsrSignInError401",
      defaultString: returnsCsrSignInError401 ?? tempLanguageKeys.returnsCsrSignInError401
    });
  }
  if (csrSignInErrorCode === 500) {
    return /*#__PURE__*/React__default["default"].createElement(index["default"], {
      langKey: "returnsCsrSignInError500",
      defaultString: returnsCsrSignInError500 ?? tempLanguageKeys.returnsCsrSignInError500
    });
  }
  return null;
};
const CsrSignInForm = () => {
  const {
    csrSignInErrorCode,
    csrSignInUrl,
    moniker: retailer
  } = ReturnsConfigProvider.useReturnsConfig();
  const {
    returnsCsrSignInTitle,
    returnsCsrSignInDetails,
    returnsCsrSignInOrderPlaceholder,
    returnsCsrSignInPrimaryButton
  } = nthHookTranslations.useTranslations();
  const {
    bodytextDefaultNone
  } = nthHookTheme.useTheme();
  const [orderId, setOrderId] = React.useState('');
  const [isDisabled, setIsDisabled] = React.useState(true);
  React.useEffect(() => {
    setIsDisabled(!!(orderId === '' || orderId.length < 3));
  }, [orderId]);
  if (!csrSignInUrl) {
    return null;
  }
  const handleInputChange = e => {
    setOrderId(e.target.value);
  };
  const handleSubmit = e => {
    e.preventDefault();
    const csrSignInForm = e.target;

    // We abort form submission if
    if (orderId === '' || orderId.length < 3) {
      return;
    }
    setSessionStorageItem('csrSignIn', 'true');
    setSessionStorageItem('orderId', orderId);
    csrSignInForm.submit();
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: CsrSignInForm_module["default"].formWrapper
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.BigHeader, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsCsrSignInTitle",
    defaultString: returnsCsrSignInTitle ?? tempLanguageKeys.returnsCsrSignInTitle
  })), csrSignInErrorCode && /*#__PURE__*/React__default["default"].createElement(ErrorBanner["default"], null, /*#__PURE__*/React__default["default"].createElement(CsrSignInErrorMessage, {
    csrSignInErrorCode: csrSignInErrorCode
  })), /*#__PURE__*/React__default["default"].createElement("p", {
    style: bodytextDefaultNone
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsCsrSignInDetails",
    defaultString: returnsCsrSignInDetails ?? tempLanguageKeys.returnsCsrSignInDetails
  })), /*#__PURE__*/React__default["default"].createElement("form", {
    className: CsrSignInForm_module["default"].form,
    action: `${csrSignInUrl}?retailer=${retailer}&order_number=${orderId}`,
    id: "csrSignInForm",
    method: "post",
    onSubmit: handleSubmit
  }, /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(TextInput__default["default"], {
    className: CsrSignInForm_module["default"].textInput,
    type: TextInput.SupportedInputType.text,
    placeholder: returnsCsrSignInOrderPlaceholder ?? tempLanguageKeys.returnsCsrSignInOrderPlaceholder,
    value: orderId,
    onChange: handleInputChange
  })), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    disabled: isDisabled,
    type: Button.ButtonType.submit
  }, returnsCsrSignInPrimaryButton ?? tempLanguageKeys.returnsCsrSignInPrimaryButton)));
};
var CsrSignInForm$1 = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(CsrSignInForm, {
  themeTokens: tokens.themeTokens
}), {
  translationKeys: tokens.translationKeys
});

exports["default"] = CsrSignInForm$1;
exports.getSessionStorageItem = getSessionStorageItem;
exports.setSessionStorageItem = setSessionStorageItem;
